// -----------------------------
// SET FIELDS.
// -----------------------------


var VatPartialClass = 'block_billing_ficoo_customer_vat_number';
var TaxCodePartialClass = 'block_billing_ficoo_customer_tax_code';
var PecPartialClass = 'block_billing_ficoo_customer_email_pec';
var ReccodePartialClass = 'block_billing_ficoo_customer_recipient_code';
var CheckboxPartialClass = 'block_billing_ficoo_invoice_requested';
var CheckboxClass = '.wc-block-components-address-form__ficoo-smart-connector-core-block_billing_ficoo_invoice_requested';

export const ficooDiv = {
    get vat() {
        // Use window.targetCountry to determine which parent container to search in
        if (typeof window.targetCountry !== 'undefined' && window.targetCountry?.id === 'billing-country') {

            // search in class name if contains VatPartialClass
            let address = document.querySelector('#billing div[class*="' + VatPartialClass + '"]'); // address section
            let other = document.querySelector('div[class*="' + VatPartialClass + '"]'); // other section
            return address || other;
        } else if (typeof window.targetCountry !== 'undefined' && window.targetCountry?.id === 'shipping-country') {
            let address = document.querySelector('#shipping div[class*="' + VatPartialClass + '"]'); // address section
            let other = document.querySelector('div[class*="' + VatPartialClass + '"]'); // other section
            return address || other;
        } else {
            let other = document.querySelector('div[class*="' + VatPartialClass + '"]'); // other section
            return other;
        }
    },

    get taxcode() {
        // Use window.targetCountry to determine which parent container to search in
        if (typeof window.targetCountry !== 'undefined' && window.targetCountry?.id === 'billing-country') {

            // search in class name if contains TaxCodePartialClass
            let address = document.querySelector('#billing div[class*="' + TaxCodePartialClass + '"]'); // address section
            let other = document.querySelector('div[class*="' + TaxCodePartialClass + '"]'); // other section
            return address || other;
        } else if (typeof window.targetCountry !== 'undefined' && window.targetCountry?.id === 'shipping-country') {
            let address = document.querySelector('#shipping div[class*="' + TaxCodePartialClass + '"]'); // address section
            let other = document.querySelector('div[class*="' + TaxCodePartialClass + '"]'); // other section
            return address || other;
        } else {
            let other = document.querySelector('div[class*="' + TaxCodePartialClass + '"]'); // other section
            return other;
        }
    },

    get emailpec() {
        // Use window.targetCountry to determine which parent container to search in
        if (typeof window.targetCountry !== 'undefined' && window.targetCountry?.id === 'billing-country') {

            // search in class name if contains PecPartialClass
            let address = document.querySelector('#billing div[class*="' + PecPartialClass + '"]'); // address section
            let other = document.querySelector('div[class*="' + PecPartialClass + '"]'); // other section
            return address || other;
        } else if (typeof window.targetCountry !== 'undefined' && window.targetCountry?.id === 'shipping-country') {
            let address = document.querySelector('#shipping div[class*="' + PecPartialClass + '"]'); // address section
            let other = document.querySelector('div[class*="' + PecPartialClass + '"]'); // other section
            return address || other;
        } else {
            let other = document.querySelector('div[class*="' + PecPartialClass + '"]'); // other section
            return other;
        }
    },

    get reccode() {
        // Use window.targetCountry to determine which parent container to search in
        if (typeof window.targetCountry !== 'undefined' && window.targetCountry?.id === 'billing-country') {
            let address = document.querySelector('#billing div[class*="' + ReccodePartialClass + '"]'); // address section
            let other = document.querySelector('div[class*="' + ReccodePartialClass + '"]'); // other section
            return address || other;
        } else if (typeof window.targetCountry !== 'undefined' && window.targetCountry?.id === 'shipping-country') {
            let address = document.querySelector('#shipping div[class*="' + ReccodePartialClass + '"]'); // address section
            let other = document.querySelector('div[class*="' + ReccodePartialClass + '"]'); // other section
            return address || other;
        } else {
            let other = document.querySelector('div[class*="' + ReccodePartialClass + '"]'); // other section
            return other;
        }
    },
    get checkbox() {
        // console.log('ficooDiv get checkbox called');
        //Checkbox is always in the "other" section.
        // use  window.ficooSection to determine if we are in address or other section
        if (typeof window.ficooSection !== 'undefined' && window.ficooSection === 'other_section') {
            console.log('Other section', document.querySelector('div[class*="' + CheckboxPartialClass + '"]'));
            return document.querySelector(CheckboxClass); // Other section

        } else {
            // return fake div like original <div class="wc-block-components-checkbox wc-block-components-address-form__ficoo-smart-connector-core-block_billing_ficoo_invoice_requested" style="display: block;"><label for="order-ficoo-smart-connector-core-block_billing_ficoo_invoice_requested"><input id="order-ficoo-smart-connector-core-block_billing_ficoo_invoice_requested" class="wc-block-components-checkbox__input" type="checkbox" aria-invalid="false" value=""><svg class="wc-block-components-checkbox__mark" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 20"><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"></path></svg><span class="wc-block-components-checkbox__label">Voglio una fattura</span></label></div>
            return {
                className: 'wc-block-components-checkbox wc-block-components-address-form__ficoo-smart-connector-core-block_billing_ficoo_invoice_requested',
                style: { display: 'block' },
                querySelector: () => {
                    return {
                        id: 'order-ficoo-smart-connector-core-block_billing_ficoo_invoice_requested',
                        className: 'wc-block-components-checkbox__input',
                        type: 'checkbox',
                        ariaInvalid: 'false',
                        value: '',
                        checked: true, // Default to checked to avoid validation issues
                        addEventListener: () => { }
                    };
                }
            };
        }
    }
}

// Always Shipping address fields.
export const ficooShippingAddressDiv = {
    get vat() {
        return document.querySelector('#shipping div[class*="' + VatPartialClass + '"]') || null;
    },
    get taxcode() {
        return document.querySelector('#shipping div[class*="' + TaxCodePartialClass + '"]') || null;
    },
    get emailpec() {
        return document.querySelector('#shipping div[class*="' + PecPartialClass + '"]') || null;
    },
    get reccode() {
        return document.querySelector('#shipping div[class*="' + ReccodePartialClass + '"]') || null;
    }

}

// Always Billing address fields.
export const ficooBillingAddressDiv = {
    get vat() {
        return document.querySelector('#billing div[class*="' + VatPartialClass + '"]') || null;
    },
    get taxcode() {
        return document.querySelector('#billing div[class*="' + TaxCodePartialClass + '"]') || null;
    },
    get emailpec() {
        return document.querySelector('#billing div[class*="' + PecPartialClass + '"]') || null;
    },
    get reccode() {
        return document.querySelector('#billing div[class*="' + ReccodePartialClass + '"]') || null;
    }

}

export const ficooInput = {
    get vat() {
        // vat input is child of ficooDiv.vat
        // if ficooDiv.vat is null, return a fake input object to avoid errors, set value to empty string
        return ficooDiv.vat ? ficooDiv.vat.querySelector('input') : {
            id: 'fake-vat',
            value: '',
            addEventListener: () => { }
        };
    },
    get taxcode() {
        // taxcode input is child of ficooDiv.taxcode
        return ficooDiv.taxcode ? ficooDiv.taxcode.querySelector('input') : {
            id: 'fake-taxcode',
            value: '',
            addEventListener: () => { }
        };
    },
    get emailpec() {
        // emailpec input is child of ficooDiv.emailpec
        return ficooDiv.emailpec ? ficooDiv.emailpec.querySelector('input') : {
            id: 'fake-emailpec',
            value: '',
            addEventListener: () => { }
        };
    },
    get reccode() {
        // reccode input is child of ficooDiv.reccode
        return ficooDiv.reccode ? ficooDiv.reccode.querySelector('input') : {
            id: 'fake-reccode',
            value: '',
            addEventListener: () => { }
        };
    },
    get checkbox() {
        return ficooDiv.checkbox ? ficooDiv.checkbox.querySelector('input') : {
            id: 'fake-checkbox',
            checked: true,
            addEventListener: () => { }
        };
    }
}

export const woocommerceFields = {
    get totalwrapper() {
        return document.querySelector('.wc-block-components-totals-footer-item');
    }
}

export const SameAddress = {
    get label() {
        return document.querySelector('.wc-block-checkout__use-address-for-billing label span');
    },
    // if we are selling downloadable products only, this checkbox does not exist
    get checkbox() {
        return document.querySelector('.wc-block-checkout__use-address-for-billing input[type="checkbox"]') || {
            id: 'fake-checkbox',
            checked: false,
            addEventListener: () => { }
        };
    }
}

export const billingCountry = {
    get select() {
        return document.getElementById('billing-country');
    }
}

export const shippingCountry = {
    get select() {
        return document.getElementById('shipping-country');
    }
}


